import styled from 'styled-components';

export const Container = styled.div``;

export const BoxValue = styled.div`
  border-radius: 4.181px;
  background-color: #efefef;
  height: 42px;
  display: flex;
  padding-left: 12px;
  font-size: 1rem;
  align-items: center;
  color: #757575;
  white-space: nowrap;
  overflow: hidden;
`;
